
import bluetick from '../../../assets/images/bluetick.svg';
import add from '../../../assets/images/icons8-plus-32.png';


export default function EquationCard ( props ) {

    const { expandIndex, handleExpand, handleActive, equation,  setCurrentEquation } = props;


    return (
        <div 
            key={ equation.equationId } 
            className={`${ expandIndex.includes(equation.equationId) 
                ? "h-[200px] flex-col py-4" 
                : "h-[50px]"} 
                ${equation.active
                    ? "bg-lightPrimary" 
                    : "bg-bgColor"} w-[500px] pl-8 pr-4 py-[12px] mt-2 rounded-sm cursor-pointer`} 
            onClick={ () => handleExpand( equation.equationId )}
        >

            
            <div className='flex justify-between w-full'
            
            >
                {equation.gameType}

                <img 
                    src={ equation?.active ? bluetick : add } 
                    alt="" 
                    className='w-6' 
                    onClick={ ( e ) =>{
                        // handleFilterEquation( equation )
                        e.stopPropagation()
                        handleActive(equation.equationId);
                        //  handleTick( e, equation.equationId )
                        }
                }
                />
            </div>
            {expandIndex.includes( equation.equationId ) ? 
            
            <div className='flex'>
                <div onClick={(e) => e.stopPropagation()} >
                    {/* <input 
                        type="number" 
                        placeholder='Exchange Unit Rate' 
                        className=' w-[300px] px-2 py-2 font-semibold outline-none mt-4' 
                        step="0.01" 
                        min="0" 
                        value={equation.exchangeUnitRate} 
                        onChange={(e) => setExchangeUnit(e.target.value)} 
                    /> */}
                    <div className='w-[300px] px-2 py-2 bg-white mt-4 flex justify-between'  >
                        { equation.exchangeUnitRate }
                    </div>
                    <div className='w-[300px] px-2 py-2 bg-white mt-4 flex justify-between'  >
                        { equation.equation }        
                        {/* <img 
                            src={edit} 
                            alt="" 
                            className='w-6' 
                            onClick={()=>setEditEquation(true)} 
                        /> */}
                    </div>
                    <div className='flex items-center mt-4'>
                        <input
                            type="checkbox"
                            checked={ equation?.showPositive } 
                        //  disabled={true}
                        />
                        <div className='ml-2'>Show Positive</div>
                    </div>
                </div>
                <div className='flex flex-col justify-end ml-10 text-white'>
                    <button 
                        className='w-[100px] h-[35px] bg-primary rounded-md ml-3' 
                        onClick={(e) => setCurrentEquation(equation)}>
                        Edit
                    </button>
                    {/* <button className='w-[100px] h-[35px] bg-attractive2 mt-2 rounded-md'
                    onClick={(e) => e.stopPropagation()}>
                        Remove
                    </button> */}
                </div>
            </div>
            
            :
            
            ""

            }

        </div>
    )
}